(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hla-lead-tracking"] && !Shopify.designMode) return;
  try {
    (() => {
    const track = (eventName, parameters = {}) => {
      const payload = { event: eventName, ...parameters };
      window.hlaEventQueue = window.hlaEventQueue || [];
      window.hlaEventQueue.push(payload);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      window.dispatchEvent(new CustomEvent(`hardwoodla:${eventName}`, { detail: parameters }));
    };
    const forms = document.querySelectorAll('#HlaLeadForm');
    forms.forEach((form) => {
      if (form.dataset.trackingReady === 'true') return;
      form.dataset.trackingReady = 'true';
      const syncAttribution = () => {
        const params = new URLSearchParams(window.location.search);
        form.querySelectorAll('[data-hla-attribution]').forEach((input) => {
          let storedValue = '';
          try { storedValue = window.sessionStorage?.getItem(`hla_${input.dataset.hlaAttribution}`) || ''; } catch (error) { /* Storage is optional. */ }
          const value = params.get(input.dataset.hlaAttribution) || storedValue;
          try { if (params.get(input.dataset.hlaAttribution)) window.sessionStorage?.setItem(`hla_${input.dataset.hlaAttribution}`, value); } catch (error) { /* Storage is optional. */ }
          input.value = value;
          input.setAttribute('value', value);
        });
        const landingInput = form.querySelector('[data-hla-landing-page]');
        if (landingInput) {
          let landingPage = window.location.href;
          try {
            landingPage = window.sessionStorage?.getItem('hla_landing_page') || landingPage;
            window.sessionStorage?.setItem('hla_landing_page', landingPage);
          } catch (error) { /* Storage is optional. */ }
          landingInput.value = landingPage;
          landingInput.setAttribute('value', landingPage);
        }
      };
      syncAttribution();
      form.addEventListener('focusin', () => {
        syncAttribution();
        if (form.dataset.started === 'true') return;
        form.dataset.started = 'true';
        track('form_start', { form_id: 'HlaLeadForm', lead_type: form.querySelector('[name="contact[Inquiry type]"]')?.value || 'flooring_inquiry' });
      }, { once: true });
      form.addEventListener('submit', () => {
        syncAttribution();
        try { sessionStorage.setItem('hla_pending_' + form.id, JSON.stringify({ at: Date.now(), type: form.querySelector('[name="contact[Inquiry type]"]')?.value || 'flooring_inquiry' })); } catch (error) {}
        track('lead_submit_attempt', { form_id: 'HlaLeadForm', lead_type: form.querySelector('[name="contact[Inquiry type]"]')?.value || 'flooring_inquiry' });
      }, { capture: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
